import { useMemo } from 'react';
import { HARMONY_PORTAL_CHAT } from '@rsos/capstone/src/constants/capabilities';
import { HARMONY_PORTAL_CHAT_PERMISSION } from '@rsos/constants/permissions';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';

const useHasAccessToHarmonyPortalChat = () => {
  const hasHarmonyPortalChatCapabilities =
    useHasCapability(HARMONY_PORTAL_CHAT);
  const hasHarmonyPortalChatPermission = useHasPermission(
    HARMONY_PORTAL_CHAT_PERMISSION,
  );

  const hasAccessToHarmonyPortalChatFeature = useMemo(() => {
    return (
      !!hasHarmonyPortalChatCapabilities?.hasCapability &&
      !!hasHarmonyPortalChatPermission?.hasPermission
    );
  }, [hasHarmonyPortalChatCapabilities, hasHarmonyPortalChatPermission]);

  return hasAccessToHarmonyPortalChatFeature;
};

export default useHasAccessToHarmonyPortalChat;
